import RootStore from '../store/RootStore';

export default function createStore() {
  const store = new RootStore();
  return store;
}
